import { ref } from 'vue';
import { defineStore } from 'pinia';
import type { ToastMessage } from "@/models/app";
import { v4 as uuidv4 } from 'uuid';

type ToastMessageWithId = ToastMessage & { id: string };

export const useToastStore = defineStore('toast', () => {

  // System toasts
  const messages = ref<Map<string, ToastMessageWithId>>(new Map());

  const add = (message: ToastMessage) => {
    const id = uuidv4();
    message.id = id;
    messages.value.set(id, message as ToastMessageWithId);
    if (message.timeout) {
      setTimeout(() => {
        messages.value.delete(id);
      }, message.timeout);
    }
  };

  const remove = (id: string) => {
    messages.value.delete(id);
  }

  function $reset() {
    messages.value.clear();
  }

  return {messages, add, remove, $reset};
});
